import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai";


// Atom we can use for storing the user's image
export const userImageAtom = atomWithStorage<string>('userImage', 'https://i1.sndcdn.com/artworks-000087535998-bv2o99-t500x500.jpg')

export const userNameAtom = atomWithStorage<string>('userName', 'Playa')

interface UserProfile {

  username: string,
  profileImg: string,
  themeSong?: string,

}

export const userAtom = atom<UserProfile>((get) => {
  return {
    username: get(userNameAtom),
    profileImg: get(userImageAtom),
    themeSong: undefined,
  }
})